import { useState, useRef, useEffect } from 'react';

/**
 * Custom hook for managing toast notifications
 * @param {number} duration - Duration in milliseconds (default: 2000)
 * @returns {Object} - { toastMessage, showToast }
 */
export function useToast(duration = 2000) {
  const [toastMessage, setToastMessage] = useState(null);
  const toastTimeoutRef = useRef(null);
  const toastMessageRef = useRef(null);

  const showToast = (message) => {
    // Clear any existing timeout
    if (toastTimeoutRef.current) {
      clearTimeout(toastTimeoutRef.current);
    }
    // Store in ref to persist across re-renders
    toastMessageRef.current = message;
    setToastMessage(message);
    toastTimeoutRef.current = setTimeout(() => {
      setToastMessage(null);
      toastMessageRef.current = null;
      toastTimeoutRef.current = null;
    }, duration);
  };

  // Restore toast message from ref if component re-renders
  useEffect(() => {
    if (toastMessageRef.current && !toastMessage) {
      setToastMessage(toastMessageRef.current);
    }
  }, [toastMessage]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    };
  }, []);

  return { toastMessage, showToast };
}

